import React from "react";
import {AppConfig} from "../../AppConfig";


class Reports extends React.Component {

    render() {
        return (
            <div>

                <h3><strong>Raporlar</strong></h3>
                <hr/>
                <ul>
                    {/*<li><a href={AppConfig.pages.report.userAndFinishedWork}>Operator Bazlı Biten İşler</a></li>*/}
                    <li><a href={AppConfig.pages.report.reportUserStatistics}>Operator İstatistikleri</a></li>
                </ul>

            </div>
        )
    }

}

export default Reports;
